// @flow

import React from 'react';
export function ThumbsUpIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1982 16H10.3022L8.00024 14.465V8.277L10.5632 4.004C10.8092 4.036 11.0002 4.246 11.0002 4.5V8C11.0002 8.552 11.4472 9 12.0002 9H15.7532L14.1982 16ZM17.7802 7.375C17.5902 7.138 17.3032 7 17.0002 7H13.0002V4.5C13.0002 3.122 11.8792 2 10.5002 2H10.0002C9.64824 2 9.32324 2.184 9.14224 2.485L6.43324 7H3.00024C2.44724 7 2.00024 7.448 2.00024 8V15C2.00024 15.552 2.44724 16 3.00024 16H6.69724L9.44524 17.832C9.60924 17.941 9.80224 18 10.0002 18H15.0002C15.4692 18 15.8742 17.674 15.9762 17.217L17.9762 8.217C18.0422 7.921 17.9692 7.611 17.7802 7.375Z"
      />
    </svg>
  );
}
